import React, { useState } from 'react';
import { WatchRender } from './WatchRender';
import { WaitlistForm } from './WaitlistForm';
import { NeedFromAbby } from './NeedFromAbby';
type WatchFeatureProps = {
  tone?: 'dark' | 'light';
  title: React.ReactNode;
  body: string;
  source: string;
  headingLevel?: 'h2' | 'h3';
};
export function WatchFeature({
  tone = 'dark',
  title,
  body,
  source,
  headingLevel = 'h2'
}: WatchFeatureProps) {
  const [face, setFace] = useState<'cream' | 'charcoal'>(tone === 'dark' ? 'cream' : 'charcoal');
  const dark = tone === 'dark';
  const Heading = headingLevel;
  return <section id="watch" aria-labelledby={`${source}-watch-title`} className={`scroll-mt-24 ${dark ? 'bg-charcoal text-cream' : 'dusk-field text-charcoal'}`} data-id="element-494" data-mp="2p7o3eccblf49">
      <div className="gutter grid items-center gap-[clamp(2.5rem,6vw,9rem)] py-[clamp(4rem,8vw,10rem)] lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]" data-id="element-495" data-mp="2u6r3rjhcux5w">
        <div className="relative mx-auto w-full max-w-[min(100%,40rem)] lg:max-w-none" data-id="element-496" data-mp="2k8uukx7zacaf">
          <div className={`grid aspect-square place-items-center ${dark ? 'bg-[#2A2826]' : 'bg-white/55'}`} data-id="element-497" data-mp="zigmtu4a6qla">
            <WatchRender face={face} className="w-[48%]" data-id="element-498" data-mp="uk5ddkhwei3l" />
          </div>
          <div className="mt-4 flex items-center justify-between gap-4" data-id="element-499" data-mp="18jeoi5r8ym0p">
            <div role="radiogroup" aria-label="Dial face" className="flex gap-2" data-id="element-500" data-mp="18ilp5pumaysl">
              {(['cream', 'charcoal'] as const).map(f => <button key={f} type="button" role="radio" aria-checked={face === f} onClick={() => setFace(f)} className={`t-label flex h-10 items-center gap-2 border px-4 text-[0.62rem] transition-colors duration-150 ${face === f ? dark ? 'border-cream text-cream' : 'border-charcoal text-charcoal' : dark ? 'border-cream/30 text-cream/75 hover:border-cream/70' : 'border-charcoal/25 text-graphite hover:border-charcoal/60'}`} data-id="element-501" data-mp="grpfey3uta9j">
                  <span aria-hidden="true" className={`h-3 w-3 rounded-full border border-gold ${f === 'cream' ? 'bg-cream' : 'bg-[#232220]'}`} data-id="element-502" data-mp="1x4wmkzn61x5k" />
                  {f === 'cream' ? 'Cream' : 'Charcoal'}
                </button>)}
            </div>
            <NeedFromAbby className="hidden sm:inline-flex" data-id="element-503" data-mp="199207bb7flw6">product renders</NeedFromAbby>
          </div>
        </div>

        <div className="max-w-[40rem]" data-id="element-504" data-mp="1e8odfkr1924z">
          <p className={`t-label flex items-center gap-3 ${dark ? 'text-gold' : 'text-gold-deep'}`} data-id="element-505" data-mp="1e9pt62izuct1">
            <span className="t-numeral" data-id="element-506" data-mp="1j8supczrm0w9">XII</span>
            <span aria-hidden="true" data-id="element-507" data-mp="1o6ufq3gr4aad">·</span> Timepieces · Coming Soon
          </p>
          <Heading id={`${source}-watch-title`} className={`t-h2 mt-5 ${dark ? '!text-cream' : ''}`} data-id="element-508" data-mp="2umem74t3keky">
            {title}
          </Heading>
          <p className={`t-lead mt-6 max-w-[44ch] ${dark ? 'text-cream/80' : 'text-graphite'}`} data-id="element-509" data-mp="2zjerhdi4hdb0">{body}</p>
          <div className="mt-10" data-id="element-510" data-mp="nwtc3iaqpx0m">
            <WaitlistForm tone={dark ? 'dark' : 'light'} source={source} data-id="element-511" data-mp="iyrvd40se9sb" />
          </div>
        </div>
      </div>
    </section>;
}